import { Card, Checkbox, Typography } from 'antd';
import { APPLICATION_CONFIRM_RESULT } from 'constants/GlobalConfig';
import { useState } from 'react';

export const INIT_FILTER_OPTIONS = [
    APPLICATION_CONFIRM_RESULT.COMMENT.KEY,
    APPLICATION_CONFIRM_RESULT.SCORING_USER_ID.KEY,
    APPLICATION_CONFIRM_RESULT.STARTED_AT.KEY,
    APPLICATION_CONFIRM_RESULT.SUBMITTED_AT.KEY,
]

const OPTIONS_DEFAULT = [
    {
        label: APPLICATION_CONFIRM_RESULT.SCORE_GIVEN_AND_SCORE_MAXIMUM.TITLE,
        value: APPLICATION_CONFIRM_RESULT.SCORE_GIVEN_AND_SCORE_MAXIMUM.KEY,
        checked: true,
    },
    {
        label: APPLICATION_CONFIRM_RESULT.ACTIVITY_PROGRESS.TITLE,
        value: APPLICATION_CONFIRM_RESULT.ACTIVITY_PROGRESS.KEY,
        checked: true,
    },
    {
        label: APPLICATION_CONFIRM_RESULT.GRADING_PROGRESS.TITLE,
        value: APPLICATION_CONFIRM_RESULT.GRADING_PROGRESS.KEY,
        checked: true,
    },
    {
        label: APPLICATION_CONFIRM_RESULT.TIMESTAMP.TITLE,
        value: APPLICATION_CONFIRM_RESULT.TIMESTAMP.KEY,
        checked: true,
    },
    {
        label: APPLICATION_CONFIRM_RESULT.COMMENT.TITLE,
        value: APPLICATION_CONFIRM_RESULT.COMMENT.KEY,
        checked: false,
    },
    {
        label: APPLICATION_CONFIRM_RESULT.SCORING_USER_ID.TITLE,
        value: APPLICATION_CONFIRM_RESULT.SCORING_USER_ID.KEY,
        checked: false,
    },
    {
        label: APPLICATION_CONFIRM_RESULT.STARTED_AT.TITLE,
        value: APPLICATION_CONFIRM_RESULT.STARTED_AT.KEY,
        checked: false,
    },
    {
        label: APPLICATION_CONFIRM_RESULT.SUBMITTED_AT.TITLE,
        value: APPLICATION_CONFIRM_RESULT.SUBMITTED_AT.KEY,
        checked: false,
    },
];

type Props = {
    onChange: any;
};

const ScoreViewOption: React.FC<Props> = ({ onChange }) => {
    const [options, setOptions] = useState(OPTIONS_DEFAULT);
    const handleChangeViewOption = (valueChange: string, checkedValue: boolean) => {
        setOptions((prev) => {
            return prev.map((item) => (item.value === valueChange ? { ...item, checked: checkedValue } : item));
        });
        onChange(valueChange);
    };

    return (
        <Card>
            <Typography style={{ margin: '0.5rem' }}> 表示情報</Typography>
            {options.map((option, index) => {
                return (
                    <Checkbox
                        key={index}
                        checked={option.checked}
                        value={option.value}
                        onChange={(event) => handleChangeViewOption(event.target.value, event.target.checked)}>
                        {option.label}
                    </Checkbox>
                );
            })}
        </Card>
    );
};

export default ScoreViewOption;
